import ListingVM from './listing-vm';
export default {
  init: function(node){
    var templates_data = JSON.parse($('#templates_json').val());
    ko.applyBindingsWithValidation(new ListingVM(templates_data), node, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  }
};
